import * as Sentry from '@sentry/react';

const serializeArg = (arg) =>{
    if (arg instanceof Error) {
        return {
            message: arg.message,
            stack: arg.stack,
            name: arg.name,
        };
    }

    try {
        return JSON.parse(JSON.stringify(arg));
    } catch {
        return String(arg);
    }
}

export default function setupConsoleErrorCapture(){
    const originalConsoleError = console.error;

    console.error = (...args) => {
        try {
            const error = args.find(arg => arg instanceof Error);

            if (error) {
                Sentry.captureException(error, {
                    level: 'error',
                    extra: {
                        consoleArgs: args.map(serializeArg),
                    },
                });
            } else {
                const message = args.map(String).join(' ');
                Sentry.captureMessage(message, {
                    level: 'error',
                    extra: {
                        consoleArgs: args.map(serializeArg),
                    },
                });
            }
        } catch (sentryError) {
            originalConsoleError('Sentry logging failed', sentryError);
        }

        originalConsoleError(...args);
    };
}


